import React from 'react';
import Price from '../../common/Price';


export default function StockOrderQuantityStatus(props) {
  const { stockOrder } = props;
  const {
    quantity,
    cashQuantity,
    quantityToDate,
    executedQuantityToDate,
    contract,
  } = stockOrder;

  if (quantity === null) {
    return (
      <>
        {quantityToDate}
        /
        {executedQuantityToDate}
        /
        <Price currency={contract.currency}>{cashQuantity}</Price>
      </>
    );
  }

  return (
    <>
      {quantityToDate}
      /
      {executedQuantityToDate}
      /
      {quantity}
    </>
  );
}
